module.exports = __webpack_public_path__ + "static/media/Centripoint-AA-standard-icon(light).dd71441b.svg";